import React, { useEffect, useRef, useState } from "react";
import AdminLayout from "./AdminLayout";
import "../Admin/admin.css";
import { endpoints } from "../_config";
import { get } from "../_services/apiService";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";


const UserProductQuotation = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5);
    const [productOrderData, setroductOrderData] = useState();
    const [productOrderItemData, setroductOrderItemData] = useState();
    const pdfRef = useRef();
    const loginId = localStorage.getItem("loginId");

    const GetProductOrder = async (loginId) => {
        try {
            const response = await get(endpoints.GetProductOrderByLoginId + "?pLoginId=" + loginId)

            if (response.isSuccess === 200) {
                setroductOrderData(response.data);
            } else {
                setroductOrderData(null);
            }
        } catch (error) {
            setroductOrderData(null);
        }
    };

    useEffect(() => {
        GetProductOrder(loginId);
    }, [loginId]);


    const data = [
        {
            id: 1,
            image: "https://imageio.forbes.com/specials-images/imageserve/5d35eacaf1176b0008974b54/0x0.jpg?format=jpg&crop=4560,2565,x790,y784,safe&height=900&width=1600&fit=bounds",
            code: "#22323",
            name: "Car",
            displayName: "Car",
            description: "Here Are The Coolest New Cars For 2020",
            isDisplay: true,
            isActive: true,
        },
        {
            id: 2,
            image: "https://imageio.forbes.com/specials-images/imageserve/5d35eacaf1176b0008974b54/0x0.jpg?format=jpg&crop=4560,2565,x790,y784,safe&height=900&width=1600&fit=bounds",
            code: "#22323",
            name: "Bike",
            displayName: "Bike",
            description: "New Bikes Launch in 2020",
            isDisplay: true,
            isActive: false,
        },
        // Add more mock data
    ];

    const totalPages = Math.ceil(data?.length / itemsPerPage);

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const generatePdf = async () => {
        const element = pdfRef.current;
        const canvas = await html2canvas(element, {
            scale: 2, // Improves quality
        });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("download.pdf");
    };


    const modelToggle = (modelname, status, item) => {
        // Get the modal element by ID

        setroductOrderItemData(item);


        const modalElement = document.getElementById(modelname);
        let modal = window.bootstrap.Modal.getInstance(modalElement);
        if (!modal) {
            modal = new window.bootstrap.Modal(modalElement);
        }
        // Show or hide the modal based on the status value
        if (status) {
            modal.show(); // Show the modal if status is true
        } else {
            modal.hide(); // Hide the modal if status is false
        }
    };


    return (
        <div>
            <AdminLayout>
                <div className="product_wepper">
                    <div className="container-fluid">
                        {/* Table Section */}
                        <div className="row mt-3 product_hedding_table_main">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Quotation No.</th>
                                        <th>Quotation Date</th>
                                        <th>Name</th>
                                        <th>Email Id</th>
                                        <th>Contact No</th>
                                        {/* <th>Entry Date</th> */}
                                        {/* <th>View</th> */}

                                    </tr>
                                </thead>
                                <tbody>
                                    {productOrderData?.length > 0 ? (
                                        productOrderData?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.orderNo}</td>
                                                <td>{item.orderDate}</td>
                                                <td>{item.name} </td>
                                                <td>{item.emailId}</td>
                                                <td>{item.mobileNo}</td>
                                                {/* <td>{item.createdDate}</td> */}
                                                {/* <td>
                                                    <span className="edit_icon_wepper" onClick={() => modelToggle('modeldata', true, item)} >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 32 32" fill="none">
                                                            <path d="M16 9.75C12.5537 9.75 9.75 12.5538 9.75 16C9.75 19.4462 12.5537 22.25 16 22.25C19.4463 22.25 22.25 19.4462 22.25 16C22.25 12.5538 19.4463 9.75 16 9.75ZM16 19.75C13.9323 19.75 12.25 18.0677 12.25 16C12.25 13.9323 13.9323 12.25 16 12.25C18.0677 12.25 19.75 13.9323 19.75 16C19.75 18.0677 18.0677 19.75 16 19.75Z" fill="black" />
                                                            <path d="M31.5881 15.3389C30.3622 13.3717 24.1243 4.75 16 4.75C7.8775 4.75 1.63787 13.3716 0.411938 15.3389L0 16L0.411938 16.6611C1.63775 18.6283 7.87569 27.25 16 27.25C24.1225 27.25 30.3621 18.6284 31.5881 16.6611L32 16L31.5881 15.3389ZM16 24.75C9.69775 24.75 4.50862 18.1404 2.99325 15.999C4.50581 13.8559 9.68162 7.25 16 7.25C22.3018 7.25 27.4907 13.8587 29.0068 16.001C27.4942 18.1442 22.3184 24.75 16 24.75Z" fill="black" />
                                                        </svg>
                                                    </span>
                                                </td> */}

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                No results found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            {/* Pagination */}
                            <nav aria-label="...">
                                <ul className="pagination justify-content-end">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={handlePrevPage}>
                                            Previous
                                        </button>
                                    </li>
                                    {Array.from({ length: totalPages }, (_, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(index + 1)}
                                            >
                                                {index + 1}
                                            </button>
                                        </li>
                                    ))}
                                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={handleNextPage}>
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </AdminLayout>
            {/* Modal */}
            <div className="modal fade" id="modeldata" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Quotation</h5>
                            <div className="send_wepper">
                                <span onClick={generatePdf}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill="none">
                                    <g clip-path="url(#clip0_701_102)">
                                        <path d="M25.6116 17.4062L16 27.0178L6.38843 17.4062L8.15625 15.6384L14.75 22.2322V0H17.25V22.2322L23.8438 15.6384L25.6116 17.4062ZM32 29.5H0V32H32V29.5Z" fill="#7e7e7e" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_701_102">
                                            <rect width="32" height="32" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                </span>
                                <span className="btn-close" style={{ margin: '0' }} data-bs-dismiss="modal" aria-label="Close"></span>
                            </div>
                        </div>
                        <div className="modal-body">
                            <div   >
                                <div ref={pdfRef} style={{ padding: 20 }}>
                                    {productOrderItemData != null ?
                                        <section>
                                            <div>
                                                <div className="container mt-5">
                                                    <header className="d-flex justify-content-between header_weepr">
                                                        <div className="logo">
                                                            <img src="images/logo-white.png" alt="" />
                                                        </div>
                                                        <div className="header_text">
                                                            <h2>QUOTATION</h2>
                                                            <p><strong>Number:</strong> {productOrderItemData.orderNo}</p>
                                                            <p><strong>Date:</strong> {productOrderItemData.orderDate}</p>
                                                        </div>
                                                    </header>

                                                    <div className="all_main_wepper">
                                                        <div className="client-details">
                                                            <strong>QUOTATIONTO:</strong>
                                                            <h3>{productOrderItemData.name}</h3>
                                                            <p><strong>Phone:</strong>{productOrderItemData.mobileNo}</p>
                                                            <p><strong>Email:</strong>{productOrderItemData.emailId}</p>
                                                        </div>

                                                        <div className="quotation-details mt-4">
                                                            <p><strong>Dear Client,</strong></p>
                                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                                                labore et
                                                                dolore magna aliqua.
                                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                                                labore et
                                                                dolore magna aliqua.
                                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                                                labore et
                                                                dolore magna aliqua.
                                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                                                labore et
                                                                dolore magna aliqua.
                                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                                                labore et
                                                                dolore magna aliqua.
                                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
                                                                labore et
                                                                dolore magna aliqua.</p>

                                                        </div>

                                                        <div className="mt-4">
                                                            <div className="product-header">
                                                                <div className="product-no"><strong>No.</strong></div>
                                                                <div className="product-description"><strong>PRODUCT DESCRIPTION</strong></div>
                                                                <div className="price"><strong>PRICE</strong></div>
                                                                <div className="quantity"><strong>QUANTITY</strong></div>
                                                                <div className="total"><strong>TOTAL</strong></div>
                                                            </div>

                                                            {productOrderItemData?.orderItem?.map((item, index) => (
                                                                <div className="product-row">
                                                                    <div className="product-no">01</div>
                                                                    <div className="product-description">
                                                                        {item.productName}<br />
                                                                        <small>Categories: {item.productSubCategoryName}, {item.categoryName}</small>
                                                                    </div>
                                                                    <div className="price">-</div>
                                                                    <div className="quantity">{item.quantity}</div>
                                                                    <div className="total">-</div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <div className="terms mt-4">
                                                            <div className="terms-conditions-row">
                                                                <div className="left-col">
                                                                    <p><strong>Terms & Conditions:</strong> Lorem ipsum dolor sit amet, consectetur
                                                                        adipiscing
                                                                        elit, sed
                                                                        do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                                                </div>
                                                                <div className="right-col">
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="footer1 text-center mt-4">
                                                            {/* <p><strong>Total: ${productOrderItemData.orderAmount}</strong></p> */}
                                                        </div>

                                                        <div className="signature">
                                                            <p>AUTHORIZED SIGN</p>
                                                        </div>

                                                        <div className="footer1 text-center mt-4">
                                                            <p>For any questions contact us at:</p>
                                                            <p><a href="mailto:Help@sparks-hvac.com">Help@sparks-hvac.com</a></p>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </section>
                                        : null}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserProductQuotation;
